import DispensaryPickupFulfillmentInfo from "./DispensaryPickupFulfillmentInfo";

export default DispensaryPickupFulfillmentInfo;
